import { render, staticRenderFns } from "./OpcionDialog.vue?vue&type=template&id=46ac834d"
import script from "./OpcionDialog.vue?vue&type=script&lang=js"
export * from "./OpcionDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports